import React from 'react';
import { StepRenderer, useHasComponent, useOrchestratorParams } from '@wix/gg-components/orchestrator';
import { StepParams, StepRenderPart } from 'types/steps';
import { useStepPageViewTracker, useBiLogger } from '../../hooks';
import styles from './AppLayout.scss';
import { DynamicSplitLayout } from '@wix/gg-common-lib/components';
import { useIsMobile } from '@wix/gg-common-lib/hooks';

export function AppLayout() {
  useBiLogger();
  useStepPageViewTracker();
  const hasMainComponent = useHasComponent<StepRenderPart>('main');
  const hasPreview = useHasComponent<StepRenderPart>('preview');
  const isMobile = useIsMobile();
  const params = useOrchestratorParams<StepParams>();

  if (!hasMainComponent && !hasPreview) {
    return <StepRenderer />;
  }

  return (
    <div className={styles.appLayout}>
      <DynamicSplitLayout ratio={params?.splitRatio}>
        {hasMainComponent && <StepRenderer<StepRenderPart> componentKey="main" />}
        {hasPreview && !isMobile && (
          <div className={styles.appLayoutPreview}>
            <div className={styles.appLayoutPreviewContent}>
              <StepRenderer<StepRenderPart> componentKey="preview" />
            </div>
          </div>
        )}
      </DynamicSplitLayout>
    </div>
  );
}
